export default {
  header: 'Uups, etwas ist schief gelaufen',
  text: 'Bitte starte die Seite neu oder klicke unten auf den Button "Zurück zum Start".',
  button: 'Zurück Zum Start',
};
